import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import { SERVER_URL } from "./ConstantsWomenCalculator";
import { Conception_EndPoint } from "./ConstantsWomenCalculator";
import { ConceptionTable } from "./Tables";
import { CyrcleLengthcomponet } from "./Component";
import SharedHelmet from "../Helmet";
const TITLE = 'حاسبة تاريخ الاخصاب - حساب ايام الاخصاب بسهولة ودقة';
const DESCRIPTION = 'حاسبة تاريخ الإخصاب، أدخلي تاريخ آخر دورة لحساب أيام الإخصاب بدقة وتحديد فرص الحمل.';
const KEYWORDS = 'حساب تاريخ الاخصاب, توقيت الاخصاب, حساب ايام الاخصاب, توقعات تاريخ الاخصاب, حاسبة فترة الاخصاب, حساب فترة الاخصاب, تحديد تاريخ الاخصاب, حاسبة توقيت الاخصاب, تحليل الاخصاب, تقويم الاخصاب, حاسبة الحمل'
const OG_URL = 'https://do-calculate.com/calculator/ar/conception/';
const apiEndpoint = `${SERVER_URL}/${Conception_EndPoint}`;
function ConceptionCalculator() {
  const [firstDayOfLastPeriod, setFirstDate] = useState();
  const [cycleLength, setCyrcleLength] = useState(28);
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [classification, setClassification] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleDateChange = (event) => {
    setFirstDate(event.target.value);
  };
  const calculateConception = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ firstDayOfLastPeriod, cycleLength }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data["result"]);
        setError(null);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="rtl">
       <SharedHelmet
             TITLE={TITLE}
             DESCRIPTION={DESCRIPTION}
             KEYWORDS={KEYWORDS}
             OG_URL={OG_URL}
           />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}> {TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  بواسطة حاسبة موعد تخصيب البويضة، يُمكنك معرفة الأيام التي تشهد
                  ارتفاعًا في مستوى الخصوبة لديك، أي وقت التبويض، وذلك لتتناسب
                  مع علاقاتك الجنسية وتحقيق فرصة الحمل. تُساعد حاسبة موعد تخصيب
                  البويضة في تحديد الأيام الأكثر خصوبة في شهرك، استنادًا إلى
                  تواريخ آخر الدورات الشهرية ومدتها. وبهذه الطريقة، يُمكنك تحديد
                  أفضل الأوقات للقيام بعلاقات مع زوجك، ومحاولة تحقيق الحمل.
                  لاستخدام حاسبة موعد تخصيب البويضة، يُرجى اتباع الخطوات البسيطة
                  التالية:
                </p>
                <ul>
                  <li>
                    أدخلي تاريخ أول يوم من آخر دورة شهرية في الخانة المخصصة
                    بصيغة يوم/شهر/سنة، مثلما في المثال التالي: 01/04/2009.
                  </li>
                  <li>
                    لضمان الدقة، يُمكنك ملء خانتي "الدورة ما قبل الأخيرة"
                    و"الدورة الثانية قبل الأخيرة" إذا كنتِ تعرفينهما.
                  </li>
                  <li>
                    حددي في الخانة الثانية مدة دورتك الشهرية، وإذا كنتِ غير
                    متأكدة، فإننا ننصح ب اختيار 28 يومًا.
                  </li>
                  <li>اضغطي على زر "احتساب ".</li>
                </ul>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  حاسبة توقيت التخصيب{" "}
                </div>
                <hr />
                <br />
                <div className=" form-group d-flex align-items-center">
                  <b>
                    {" "}
                    <label className="form-label ms-2">
                      <strong>أول يوم</strong> في آخر دورة شهرية
                    </label>
                  </b>
                  <br />
                  <input
                    type="date"
                    id="weightNumber"
                    value={firstDayOfLastPeriod}
                    onChange={handleDateChange}
                    className="form-control ml-2"
                    style={{ width: "145px" }}
                    placeholder="175"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    {" "}
                    <label htmlFor="CycleLength" className="form-label ms-2">
                      متوسط الوقت بين الدورات
                    </label>
                  </b>
                  <CyrcleLengthcomponet handleDateChange={setCyrcleLength} />
                  <div className="input-group-append">
                    <span className="input-group-text ">يوم</span>
                  </div>
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateConception}
                         >
                    احسب
                    </button>                </div>
              </div>
              <div className="col-12 col-md-7">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> حدث خطأ :</u>
                    </b>{" "}
                    يُرجى إدخال جميع الحقول بالشكل الصحيح.{" "}
                  </div>
                )}
                {result && (
                  <div>
                    <h4>
                      <div className="p-3 mb-2 bg-success text-white">
                        النتائج:{" "}
                      </div>
                    </h4>
                    <hr />
                    <ConceptionTable result={result}></ConceptionTable>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
                    <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">وصف حاسبة توقيت التخصيب : </div>
              <div className="info-section-body">
                <h2 style={{ fontSize: "15px" }}>
                  {" "}
                  <u>
                    <b>النافذة الخصبة</b>{" "}
                  </u>{" "}
                </h2>
                <p>
                  النافذة الخصبة هي فترة تستمر لمدة ثلاثة أيام تكون فيها
                  احتمالية حدوث حمل عند المرأة هي الأعلى. يتم تعريف التخصيب
                  عادةً كبداية الحمل، عندما يتم تخصيب البويضة. يمكن أن يحدث ذلك
                  إما من خلال تخصيب في المختبر أو عن طريق العلاقة الحميمة. في
                  حالة العلاقة الحميمة، يظل الحيوان المنوي صالحًا داخل جسم
                  المرأة لمدة تصل إلى 5 أيام (قد تصل إلى 7 أيام في بعض الحالات).
                  لذا، عندما تحاولين الحمل، العلاقة الحميمة المنتظمة قبل 5 أيام
                  من التبويض وفي يوم التبويض نفسه يمكن أن تزيد من احتمالية
                  التخصيب بنجاح. يُعرف ذلك بالنافذة الخصبة. علاوة على ذلك، أظهرت
                  الدراسات أنه في غضون هذه النافذة، تعتبر آخر 3 أيام هي الأكثر
                  خصوبة، والعلاقة الحميمة خلال هذه الفترة ستؤدي إلى حدوث الحمل
                  في حوالي 30% من الحالات.
                </p>
                <hr />
                <h2 style={{ fontSize: "15px" }}>
                  {" "}
                  <u>
                    <b>الحب والإنجاب</b>{" "}
                  </u>{" "}
                </h2>
                <p>
                  الرغبة في الإنجاب تتعلق بالحب لشريكك وللطفل الذي ستراقب نموه.
                  بغض النظر عن مدى عمق هذا الرغبة في معظم الأزواج، فإن الحياة
                  غالبًا ما تحول دون ذلك. نشعر بالتوتر والقلق نتيجة العمل ونقضي
                  معظم وقتنا في التعامل مع الانشغالات اليومية والأعمال المنزلية.
                  وبالتالي، لا نجد الوقت الكافي أو لا نكون لدينا الرغبة للممارسة
                  الحميمة بقدر ما قد نرغب. ومع ذلك، أول شيء يجب معرفته عندما
                  تحاول الحمل هو أن العلاقة الحميمة المنتظمة مع شريكك هي أفضل
                  استعداد على الإطلاق. عندما تحاولين الحمل، يجب أن تمارسي
                  العلاقة الحميمة بانتظام - على الأقل مرتين إلى ثلاث مرات في
                  الأسبوع - حتى عندما لا تعتقدين بالضرورة أنك خصبة أو قريبة من
                  يوم التبويض. العلاقة الحميمة المنتظمة تجهز جسم المرأة للإنجاب
                  وترفع المستوى الهرموني المرتبط به. ترتبط انخفاض الخصوبة نفسه
                  بانخفاض الشعور بالجنسية. يعزز نمط حياتك وعلاقاتك فرص الحمل.
                  العلاقة الحميمة المنتظمة أيضًا تخلق ظروفًا أكثر ملائمة في
                  المهبل. وجود مخاط الرحم عالي الجودة (أو شبيه بصفار البيض) يعزز
                  الخصوبة عن طريق خلق ظروف أكثر ملائمة في المهبل تساعد في حماية
                  الحيوانات المنوية وتمديد عمرها الفعال، وبالتالي تمديد النافذة
                  الخصبة.
                </p>
                <hr />
                <h2 style={{ fontSize: "15px" }}>
                  {" "}
                  <u>
                    <b>جعل نافذة الخصوبة تعمل لصالحك</b>{" "}
                  </u>{" "}
                </h2>
                بعد تحقيق نمط من العلاقة الحميمة المنتظمة، يجب التعرف على تلك
                الأيام القليلة قبل التبويض وتشمل يوم التبويض نفسه. ستزيد تحديد
                هذه الـ"نافذة" فرصك بشكل كبير للحمل. يمكن لمحوّل التخصيب المذكور
                أعلاه مساعدتك في عملية تتبع دورتك البيولوجية الشخصية، وبالتالي
                يساعدك في تحديد نافذة الخصوبة الخاصة بك. لاستخدام المحوّل، قم
                بتسجيل أول يوم من دورتك الحالية. ثم قم بتسجيل طول الدورة حتى
                الدورة التالية. أخير
                <hr />
                <b>تاريخ اخر مراجعة : </b>
                28/02/2026
              </div>
            </div>
          </div>
          <br />
          <u>
            {" "}
            <h2>اسئلة متكررة</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>ماذا يحدث أثناء الإخصاب؟</h3>
              </div>
              <div className="info-section-body">
                داخل مبيضيك كل شهر، تبدأ مجموعة من البيض في النمو في أكياس صغيرة
                مملوءة بالسوائل تُسمى الزُّوَائِد. يحدث التبويض عندما تنفجر إحدى
                البيضات من الزُّوَائِد، وعادةً ما يحدث ذلك بحوالي أسبوعين قبل
                بدء فترة الدورة الشهرية. بعد خروج البيضة من الزُّوَائِد، يقوم
                جسمك بإطلاق هرمون يساعد على تكثيف بطانة رحمك استعدادًا لاستقبال
                البيضة. تتحرك البيضة عبر الأنبوب الرحمي حيث يحدث الإخصاب. تبقى
                البيضة في الأنبوب الرحمي لمدة حوالي 24 ساعة في انتظار التخصيب عن
                طريق حيوان منوي واحد.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>ما هو التخصيب؟</h3>
              </div>
              <div className="info-section-body">
                بعد التبويض، تبقى بيضتك في الأنبوب الرحمي لمدة 12 إلى 24 ساعة في
                انتظار تخصيبها من قبل واحدة من 250 مليون حيوان منوي (في المتوسط)
                يُطلقها شريكك خلال الجماع. عندما يُطلق شريكك حيوانه المنوي،
                ينتقل الحيوانات المنوية عبر مهبط مهبِطِّك وداخل رحمك حيث البيضة
                المخصّبة في الأنبوب الرحمي. تنجح فقط حوالي 400 حيوان منوي في
                الوصول إلى البيضة بعد رحلة استغرقت حوالي 10 ساعات، وفقًا
                للمتوسط.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>متى يحدث التخصيب؟</h3>
              </div>
              <div className="info-section-body">
                لحدوث التخصيب، يجب أن تصل الحيوانات المنوية إلى البيضة في فترة
                زمنية محددة. يمكن للحيوانات المنوية البقاء على قيد الحياة لمدة
                تصل إلى 72 ساعة بعد القذف، ولكن يمكن للبيضة البقاء لا أكثر من 24
                ساعة بعد التبويض. إذا وصلت الحيوانات المنوية إلى الأنبوب الرحمي
                مبكرًا جدًا، فإنها تخاطر بالموت قبل وصول البيضة. وإذا وصلت
                الحيوانات المنوية إلى الأنبوب الرحمي متأخرة جدًا، ستكون البيضة
                قد انتقلت بالفعل. بالإضافة إلى ذلك، توجد البيضة في أحد أنابيب
                الفالوب في شهر معين فقط.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ماذا يحدث عند وصول الحيوان المنوي إلى البيضة؟
                </h3>
              </div>
              <div className="info-section-body">
                قبل التخصيب، ستحيط المئات من الحيوانات المنوية بالبيضة أثناء
                محاولتها الوصول إلى نواة البيضة. ستنجح حيوان منوي واحد فقط في
                اختراق الغشاء الخارجي للبيضة. بعدما يخترق الحيوان المنوي البيضة،
                تحدث ردة فعل كيميائية فورية تمنع حيوانات منوية أخرى من اختراقها.
                يتجمع الكروموسومات التي تحملها الحيوان المنوي والبيضة ثم تحدث
                التخصيب رسميًا. بعد حوالي أسبوع، تصل كرة مكونة من حوالي 100 خلية
                (تُسمى الكيسة المزرعة) إلى رحمك وتتم زرعها في بطانة الرحم.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كيف يمكنني زيادة فرص الحمل؟
                </h3>
              </div>
              <div className="info-section-body">
                عندما يتعلق الأمر بتحقيق الحمل، الوقت هو الأمر الأهم. لزيادة فرص
                الحمل، حاولي ممارسة الجنس في أي وقت بين 72 ساعة قبل التبويض و24
                ساعة بعد التبويض.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>كيف يمكنني التحضير للحمل؟</h3>
              </div>
              <div className="info-section-body">
                أفضل ما يمكنك القيام به للتحضير للحمل هو جعل جسمك في أفضل حالة
                ممكنة لإنجاب طفل. يجب عليك التوقف عن تناول الكحول والتدخين
                وتناول الأدوية، حتى الأدوية البدون وصفة طبية. يجب عليك إبلاغ
                طبيبك بخططك للحمل وطلب رأيه إذا كنتي بحاجة للاستمرار في تناول
                الأدوية التي تحتوي على وصفة طبية. قبل ثلاثة أشهر على الأقل من
                تخطيطك لمحاولة الحمل، يجب أن تبدأ في تناول فيتامين متعدد
                الفيتامينات يحتوي على ما لا يقل عن 400 ميكروغرام من حمض الفوليك
                لتقليل مخاطر تشوهات الولادة لطفلك.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل سأعلم بأنني حامل على الفور؟
                </h3>
              </div>
              <div className="info-section-body">
                هرمون الحمل (HCG)، وهو هرمون الحمل، موجود في دمك عقب الإخصاب.
                ومع ذلك، لا تستطيع اختبارات الحمل اكتشاف HCG في البول الخاص بك
                حتى بعد تعلق البيضة بالرحم أثناء التزاوج. في أقرب الحالات، لن
                تظهر اختبارات الحمل التي تباع بدون وصفة طبية إيجابية إلا بعد
                تسعة إلى عشرة أيام من التبويض. معظم النساء لا يشعرن بأعراض الحمل
                المبكرة إلا بعد التزاوج، ولكن بعضهن قد يلاحظن الأعراض مبكرًا.
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default ConceptionCalculator;
